import type { Sport } from '@h2h/shared';
import type { EnteredRound } from '../../lib/api';
import { RoundDateStrip } from '../../components/play/RoundDateStrip';

/** Profile round browser — same date strip as the Stages tab. */
export function ProfileRoundChips({
  rounds,
  selectedId,
  onSelect
}: {
  rounds: EnteredRound[];
  selectedId: string;
  sport: Sport;
  onSelect: (roundId: string) => void;
}) {
  const items = rounds.map((r) => ({
    roundId: r.roundId,
    kickoffAt: r.firstKickoffAt,
    status: r.status
  }));

  return <RoundDateStrip items={items} selectedId={selectedId} onSelect={onSelect} />;
}
